import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    Input,
    OnChanges,
    OnDestroy,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SVGCacheService } from './svg-cache.service';

@Component({
    selector: 'sb-inline-svg',
    templateUrl: './inline-svg.component.html',
    styleUrls: ['./inline-svg.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InlineSVGComponent implements OnChanges, AfterViewInit, OnDestroy {
    @Input() url: string;

    private unsubscriber = new Subject<void>();

    constructor(
        private svgCacheService: SVGCacheService,
        private elementRef: ElementRef,
    ) {}

    ngAfterViewInit() {
        this.setSVG(this.url);
    }

    ngOnChanges() {
        this.setSVG(this.url);
    }

    private setSVG(url: string) {
        if (!this.elementRef) {
            return;
        }
        this.svgCacheService
            .getSVG(url)
            .pipe(takeUntil(this.unsubscriber))
            .subscribe((svg: SVGElement) => {
                this.elementRef.nativeElement.innerHTML = svg.outerHTML;
            });
    }

    ngOnDestroy() {
        this.unsubscriber.next();
        this.unsubscriber.complete();
    }
}
